// extracted by mini-css-extract-plugin
export default {"title":"Statistic_title__3YYlZ"};